// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AttachmentOut = zod.object({
  "content_type": zod.string(),
  "created_at": zod.iso.datetime({"offset":true}),
  "filename": zod.string(),
  "id": zod.uuid(),
  "is_image": zod.boolean(),
  "size_bytes": zod.int()
});

export type AttachmentOut = zod.input<typeof AttachmentOut>;
export type AttachmentOutOutput = zod.output<typeof AttachmentOut>;
